import store from '@/store';

const axios = require('axios').default;
axios.defaults.timeout = 30000; // 30 seconds

axios.interceptors.request.use(
  (config) => {
    const session = localStorage.getItem('session');
    if (session) config.headers.session = session;

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const { code, response } = error;
    const { status, data } = response || {};

    if (code === 'ECONNABORTED') {
      // Handle request timeout error
      await store.dispatch('showAlertSnackBar', { text: 'Something went wrong. Please try again' });
    } else if (status === 401 && data?.message === 'UNAUTHORIZED') {
      await store.dispatch('handleUnauthorizedAccess', data.error);
    } else if (status === 403 && data?.message === 'SESSION_EXPIRED') {
      await store.dispatch('handleExpiredSession');
    } else if (status === 403 && data?.message === 'ACCESS_RESTRICTED') {
      await store.dispatch('handleRestrictedAccess', data);
    } else {
      // Handle rest of the errors
    }

    return Promise.reject(error);
  },
);

export default axios;
